import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as constrainElements from "./constrainElements";
import * as removeConstraint from "./removeConstraint";
import * as editConstraint from "./editConstraint";
import * as retrieveElementConstraints from "./retrieveElementConstraints";
import * as retrieveConstraints from "./retrieveConstraints";
import * as retrieveConstraint from "./retrieveConstraint";

const initialState: State = {
  constrainElements: constrainElements.initialState,
  removeConstraint: removeConstraint.initialState,
  editConstraint: editConstraint.initialState,
  retrieveElementConstraints: retrieveElementConstraints.initialState,
  retrieveConstraints: retrieveConstraints.initialState,
  retrieveConstraint: retrieveConstraint.initialState,
};

const reduceState = combineStateReducer(initialState, {
  constrainElements: constrainElements.reduceState,
  removeConstraint: removeConstraint.reduceState,
  editConstraint: editConstraint.reduceState,
  retrieveElementConstraints: retrieveElementConstraints.reduceState,
  retrieveConstraints: retrieveConstraints.reduceState,
  retrieveConstraint: retrieveConstraint.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...constrainElements.createSelector(() => getState().constrainElements),
    ...removeConstraint.createSelector(() => getState().removeConstraint),
    ...editConstraint.createSelector(() => getState().editConstraint),
    ...retrieveElementConstraints.createSelector(
      () => getState().retrieveElementConstraints,
    ),
    ...retrieveConstraints.createSelector(() => getState().retrieveConstraints),
    ...retrieveConstraint.createSelector(() => getState().retrieveConstraint),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
